import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthRedirectService } from '../../auth/auth-redirect.service';
import { UserManager } from '../../auth/user-manager';
import { AuthUserService } from '../../init/auth-user.service';
import { ChatHubService } from '../signalr/chat-hub.service';
import { NavbarIndicators, NavbarIndicatorsService } from './navbar-indicators.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.less'],
  standalone: false
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {

  @Output()
  onViewInit: EventEmitter<any> = new EventEmitter();

  username: string = '';

  sub1: Subscription | null = null;

  indicators: NavbarIndicators = { coursesInProgress: 0, tracksInProgress: 0, certificatesAvailable: 0, unreadMessages: 0 };

  private indicatorsSub: Subscription | null = null;

  constructor(
    private authUserService: AuthUserService,
    private authRedirectService: AuthRedirectService,
    private navbarIndicatorsService: NavbarIndicatorsService,
    private chatHubService: ChatHubService,
  ) {
    if (this.authUserService.isAnonymous) {
      this.username = 'Visitante';
    } else {
      const user = this.authUserService.getCurrentUser();
      this.username = (!user.isAnonymous ? user.username : null)
        ?? UserManager.getUserInfo()?.username
        ?? 'Usuário';
    }
  }

  get isAnonymous(): boolean {
    return this.authUserService.isAnonymous;
  }

  ngOnDestroy(): void {
    this.sub1?.unsubscribe();
    this.indicatorsSub?.unsubscribe();
  }

  ngOnInit() {
    if (!this.isAnonymous) {
      this.indicatorsSub = this.navbarIndicatorsService.indicators$.subscribe((indicators) => {
        this.indicators = indicators;
      });
      this.navbarIndicatorsService.refresh();
      this.navbarIndicatorsService.refreshUnreadMessages();

      this.chatHubService.connect().then(() => {
        this.chatHubService.unreadCountChanged$.subscribe(() => {
          this.navbarIndicatorsService.refreshUnreadMessages();
        });
      }).catch(() => {/* SignalR unavailable — badge updates on next page load */});
    }
  }

  public logout() {
    this.authRedirectService.logout();
  }

  redirectToLogin(): void {
    this.authRedirectService.redirectToAuthentication();
  }

  ngAfterViewInit(): void {
    this.onViewInit.emit();
  }
}
